import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 外部ETフォーム - チャットアプリ連携一覧取得
export async function getOutsideEntryFormChatApps(id: string) {
  try {
    const path = "outsideEntryFormChatApps";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// 外部ETフォーム - チャットアプリ連携詳細取得
export async function getOutsideEntryFormChatApp(id: string) {
  try {
    const path = "outsideEntryFormChatApp";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.detail_data && response.data.detail_data.length > 0) {
      return response.data.detail_data[0];
    }
    return null;
  } catch (error) {
    return null;
  }
}
// 外部ETフォーム - チャットアプリ連携詳細編集
export async function putOutsideEntryFormChatApp(editData: EditDataDifine) {
  try {
    const path = "outsideEntryFormChatApp";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 外部ETフォーム - チャットアプリ連携登録
export async function postOutsideEntryFormChatApp(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntryFormChatApp";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 外部ETフォーム - チャットアプリ連携削除
export async function deleteOutsideEntryFormChatApp(id: string) {
  try {
    const path = "outsideEntryFormChatApp";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
